export default __webpack_public_path__ + "static/media/lng-icon.47db1e2a.svg";